// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__oimTa","title":"NotFound_title__0pk7o","subTitle":"NotFound_subTitle__l2eMP","backButton":"NotFound_backButton__cwVpS"};